import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'devideby',
    pure: true,
    standalone: false
})
export class DevidebyPipe implements PipeTransform {
	transform(value: number, devisor: number) {
		if (!devisor) {
			return value;
		}
		return value / devisor;
	}
}
